import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export const AdminAccessDenied = ({ section }) => (
    <div className="mx-auto max-w-3xl px-6 py-20 text-center" data-testid="admin-access-denied">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#0B1120] text-[#D4AF37]">
            <ShieldAlert size={24} strokeWidth={1.6} />
        </div>
        <h1 className="mt-6 font-adminDisplay text-3xl font-bold tracking-tight text-[#0F172A]">Access restricted</h1>
        <p className="mt-3 text-sm leading-relaxed text-[#64748B]">
            Your administrator role does not include access to {section}. Please contact a Super Admin if you need this permission.
        </p>
        <Link
            to="/admin"
            data-testid="access-denied-dashboard-link"
            className="mt-8 inline-flex rounded-md bg-[#0B1120] px-6 py-3 text-xs font-bold uppercase tracking-[0.16em] text-white transition-colors duration-200 hover:bg-[#1E293B] focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
        >
            Back to Dashboard
        </Link>
    </div>
);
